export default __webpack_public_path__ + "static/media/ChallengeRankThird.9408879b.svg";